var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "row pt-3" }, [
        _c("div", { staticClass: "col-6" }, [
          _c("div", { staticClass: "border border-gray-500" }, [
            _c(
              "div",
              { staticClass: "p-2" },
              [
                _c(
                  "quick-send-list-panel",
                  _vm._b(
                    {},
                    "quick-send-list-panel",
                    _vm.quickSendListPanel,
                    false
                  )
                ),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-6" }, [
          _c("div", { staticClass: "border border-gray-500" }, [
            _c("div", { staticClass: "p-2" }, [
              _c(
                "div",
                { staticClass: "d-flex justify-content-end" },
                [
                  _c("add-send-list-conversation-item-panel"),
                  _vm._v(" "),
                  _c("export-item-panel"),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row pt-3" },
        [
          _c("div", { staticClass: "col-6" }, [
            _c("div", { staticClass: "border border-gray-500" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "p-2" },
                [
                  _c(
                    "div",
                    { staticClass: "mt-2" },
                    [
                      _c(
                        "brand-toggle",
                        _vm._b({}, "brand-toggle", _vm.brandToggle, false)
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "send-list-on-send-list-page",
                    _vm._b(
                      {},
                      "send-list-on-send-list-page",
                      _vm.sendListOnSendListPage,
                      false
                    )
                  ),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("content-tabs-on-send-list-page"),
        ],
        1
      ),
      _vm._v(" "),
      _c("modal-send-list-form"),
      _vm._v(" "),
      _c("quick-bulk-message", {
        attrs: { excludedConversationIds: _vm.excludedConversationIds },
      }),
      _vm._v(" "),
      _c("email-bulk-message-dialog", {
        attrs: { excludedConversationIds: _vm.excludedConversationIds },
      }),
      _vm._v(" "),
      _c("modal-add-send-list-conversation-form"),
      _vm._v(" "),
      _c("modal-edit-send-list-conversation-form"),
      _vm._v(" "),
      _c(
        "conversation-dialog",
        _vm._b({}, "conversation-dialog", _vm.chatProps, false)
      ),
      _vm._v(" "),
      _c("move-to-group-dialog", {
        attrs: { "search-url": _vm.sendListSearchUrl },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pt-2 pb-2 bg-gray-500 text-center" }, [
      _c("h5", { staticClass: "mb-0" }, [_vm._v("GROUPS")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }